import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useTranscriber } from "../../../hooks/useTranscriber.ts";
import download from 'downloadjs';

import CreateInputFile from "./CreateInputFile.jsx";
import TranscriberFileUpload from "./TranscriberFileUpload.jsx";
import VttTest from "./VttTest.jsx";

import { useStore } from '../../../hook-store/store';
import { 
    textToFile,
    textToSrtFile,
    srtTextToVttFile,
    srtToVtt,
 } from '../../../utils/text-util.js';

import { marks } from '../../../utils/marks';
import './FileControl.css';

// let vttTestEl;

function FileControl(props) {
    const {
        uploadApp,
    } = props;

    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    // console.log('store-App.tsx', store);
    const { mlIsBusy } = store.uiStore;
    const { 
        mlSpeechCurrentAudioData,
        mlSpeechText,
        mlSpeechSrtText,
    } = store.mlSpeechStore;

    // console.log(mlSpeechCurrentAudioData)
    const [transcribeTextFile, setTranscribeTextFile] = useState();
    const [transcribeSrtFile, setTranscribeSrtFile] = useState();
    const [transcribeVttFile, setTranscribeVttFile] = useState();
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedUploadTextFile, setSelectedUploadTextFile] = useState();

    useEffect(() => {
        if (mlSpeechSrtText) {
            createSrtFileHandler(mlSpeechSrtText);
            createVttFileHandler(mlSpeechSrtText);
        }

        if (mlSpeechText) {
            createTextFileHandler(mlSpeechText);
        }

    },[mlSpeechText, mlSpeechSrtText]);


    const textDownloadHandler = (text) => {
        download(
            text, 
            `audio-transcript-${Date.now()}.txt`, 
            "text/plain"
        );
    };

    const textSrtDownloadHandler = (text) => {
        download(
            text, 
            `audio-transcript-${Date.now()}.srt`, 
            "text/plain"
        );
    };

    const vttFileDownloadHandler = (vttFile) => {
        download(
            vttFile, 
            `audio-transcript-${Date.now()}.vtt`, 
            "text/vtt"
        );
    };

    const createTextFileHandler = (text) => {
        const textFile = textToFile(
            text,
            `audio-transcript-${Date.now()}`,
        );
        setTranscribeTextFile(textFile);
    };

    const createSrtFileHandler = (text) => {
        const srtFile = textToSrtFile(
            text,
            `audio-transcript-${Date.now()}`,
        );
        setTranscribeSrtFile(srtFile);
    };

    const createVttFileHandler = (srtText) => {
        const vttFile = srtTextToVttFile(
            srtText,
            `audio-transcript-${Date.now()}`,
        );
        setTranscribeVttFile(vttFile);
    };




    let fileControlBody;

    if (!mlIsBusy && mlSpeechText) {
        fileControlBody = (
            <div>
                <div className="transcriberUploadTestSubtitle">
                    <div>{t('audioTranscriber33', 'Test subtitles')}</div>
                    <VttTest 
                        transcribeVttFile={transcribeVttFile}
                    />
                </div>

                <div className="transcribeFileControlRow">
                    <div className="transcribeFileControlRowTitle">
                        {t('audioTranscriber34', 'Download files')} {marks.downloadMark}
                    </div>
                    <div className="transcribeFileControlButtons">
                        <button className="btnBase"
                            onClick={() => {
                                textDownloadHandler(mlSpeechText);
                            }}
                        >
                            {marks.fileTextOMark} 
                            {' '}
                            {t('audioTranscriber15', 'Download text')} 
                            {' '}{marks.downloadMark}
                        </button>
                        {mlSpeechSrtText && (
                            <button className="btnBase"
                                onClick={() => {
                                    textSrtDownloadHandler(mlSpeechSrtText);
                                }}
                            >
                                {marks.fileTextOMark} 
                                {' '}
                                {t('audioTranscriber35', 'Download srt file')}
                                {' '}{marks.downloadMark}
                            </button>
                        )}
                        {transcribeVttFile && (
                            <button className="btnBase"
                                onClick={() => {
                                    vttFileDownloadHandler(transcribeVttFile);
                                }}
                            >
                                {marks.fileTextOMark} 
                                {' '}
                                {t('audioTranscriber36', 'Download vtt file')}
                                {' '}{marks.downloadMark}
                            </button>
                        )}
                    </div>
                </div>

                <div className="transcribeFileControlRow">
                    <div className="transcribeFileControlRowTitle">
                        {t('audioTranscriber37', 'Upload files')} {marks.uploadMark}
                    </div>
                    <div className="transcribeFileControlButtons">
                        <button className="btnBase"
                            onClick={() => { 
                                setSelectedUploadTextFile(transcribeTextFile);
                                // createTextFileHandler(mlSpeechText);
                                setShowUploadModal(true);
                            }}
                        >
                            {marks.fileTextOMark} 
                            {' '}
                            {t('audioTranscriber16', 'Upload text file')}
                            {' '} 
                            {marks.uploadMark}
                        </button>
                        <button className="btnBase"
                            onClick={() => { 
                                setSelectedUploadTextFile(transcribeSrtFile);
                                setShowUploadModal(true);
                            }}
                        >
                            {marks.fileTextOMark} 
                            {' '}
                            {t('audioTranscriber38', 'Upload srt file')}
                            {' '} 
                            {marks.uploadMark}
                        </button>
                        <button className="btnBase"
                            onClick={() => { 
                                setSelectedUploadTextFile(transcribeVttFile);
                                setShowUploadModal(true);
                            }}
                        >
                            {marks.fileTextOMark} 
                            {' '}
                            {t('audioTranscriber39', 'Upload vtt file')}
                            {' '} 
                            {marks.uploadMark}
                        </button>

                        <CreateInputFile />
                    </div>
                </div>

                {/* {selectedUploadTextFile && (
                    <div>selected-txt-name: {selectedUploadTextFile.name}</div>
                )} */}

                {showUploadModal && (
                    <TranscriberFileUpload 
                        // uploadFiles={[transcribeTextFile]}
                        uploadFiles={[selectedUploadTextFile]}
                        setShowUploadModal={setShowUploadModal}
                        uploadApp={uploadApp}
                    />
                )}

            </div>

                
        );
    }

    return (
        <div className="transcribeFileControl">
            {fileControlBody}

            {/* {!mlIsBusy && mlSpeechCurrentAudioData && (
                <div>
                    <CreateAudioFile />
                </div>
            )} */}
            {/* {mlSpeechCurrentAudioData && transcribeVttFile && (
                <video controls width="640" height="264">
                    <source 
                    src={mlSpeechCurrentAudioData.url} 
                    type="video/mp4" 
                    />
                    <track 
                    kind="captions" 
                    src={URL.createObjectURL(transcribeVttFile)}
                    srclang="en" label="English" default 
                    />
                    Your browser does not support the video tag.
                </video>
            )} */}
        </div>
    );
}

export default FileControl;
